import React, { Component } from "react";
import { Link } from "react-router-dom";
import TextField from "../component/TextField";
import CheckBox from "../component/CheckBox";
import FpgDeleteIcon from "../icons/fpgdeleteicon";
import FpgDisableIcon from "../icons/fpgdisableicon";
import FpgpublishIcon from "../icons/fpgpublishicon";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";
import Loader from "../component/loader";
import DraggerIcon from '../icons/draggericon';
import FpgMinusIcon from '../icons/fpgminusicon';
import FpgPlusIcon from '../icons/fpgplusicon';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//Service import
import service from "../services";
//Validation import
import SimpleReactValidator from "simple-react-validator";

// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

//Redux Connect
import { connect } from "react-redux";
import moment, { min } from "moment";
import TextEditor from "../component/TextEditor";
let sub;

const mapStateToProps = (state) => ({
  MemberShipEditListId: state.MemberShipEditListId,
});

// const mapDispatchToProps = (dispatch) => {
//   return bindActionCreators(ActCreators, dispatch);
// };
class ProductMemberDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      getAlldataProductEditList: [],
      loaderFlag: false,
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      name: "",
      price: {
        yearly: [{
          _id: (new Date().getTime() + Math.floor(Math.random() * 100000)).toString(),
          amount: 0,

        }, {
          _id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString(),
          amount: 0,

        }, {
          _id: (new Date().getTime() + Math.floor(Math.random() * 1000)).toString(),
          amount: 0,

        }]
      },
      changeCategoryTitleName: false,
      getLastUpdated: "",
      discardPopup: false,
      data: [
        {
          "label": "MEMBERSHIP DETAILS",
          "Content": "This is content for Tab 1",
        }
      ],
      Benefits: [{
        _id: Math.random(),
        benefit_description: EditorState.createEmpty(),
        redemption_description: EditorState.createEmpty(),
      }],
      group: '',
      monthlyInstallments: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  componentDidMount() {
    this.getAllProductEditListdetails();
    this.getProductEditListdetails();
    this.getLastUpdatedTimeandDate();
    this.setState({
      loaderFlag: true,
    });
  }

  closeAdminUser = () => {
    this.setState({
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      discardPopup: false
    });
  };

  onInputMax = (e, id) => {

    let newData = this.state.price
    const { name, value } = e.target
    newData.yearly.forEach(item => {
      if (item._id === id) {
        item[name] = parseInt(value)
      }
    })
    // const price = this.state.price;
    // price.yearly[e.target.name] = e.target.value;
    // price.monthly[e.target.name] = e.target.value / 12
    this.setState({
      price: newData,
    });
  };

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };


  getProductEditListdetails = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "ticketCms|membership|getDetail":
          var Benefits = response.data.benefits.map((item) => {
            var data = {
              _id: item._id,
              benefit_description: item.benefit_description,
              redemption_description: item.redemption_description
            }
            return data
          })
          if (Benefits !== undefined) {
            const docs = Benefits.map((e) => {
              const blocksFromHtml = htmlToDraft(e ?.benefit_description);
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(
                contentBlocks,
                entityMap
              );
              e.benefit_description = EditorState.createWithContent(contentState);
              return e;
            });
            const red = Benefits.map((e) => {
              const blocksFromHtml = htmlToDraft(e ?.redemption_description);
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(
                contentBlocks,
                entityMap
              );
              e.redemption_description = EditorState.createWithContent(contentState);
              return e;
            });
          }
          this.setState({
            getAlldataProductEditList: response.data,
            name: response.data.name,
            price: response.data.price,
            accessType: response.data.accessType,
            status: response.data.status,
            group: response.data.group,
            Benefits: Benefits,
            // monthlyInstallments: response.data.monthlyInstallments
          },
            () => {
              if (!this.state.price.monthly) {
                this.setState({
                  price: {
                    yearly: this.state.price.yearly,
                  }
                })
              }

              this.setState({
                loaderFlag: false,
              });
            }
          );
          break;
        case "ticketCms|membership|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState({
              loaderFlag: false,
            }, () => this.apiserve.success("MemberShip updated successful.")) || this.props.history.push({ pathname: "/member-list" })
          }

          break;
        case "ticketCms|membership|updateStatus":
          this.props.history.push("/member-list");
          break;
        case "ticketCms|membership|getLastUpdated":
          this.setState({
            getLastUpdated: response.data,
          });
          break;
        case "ticketCms|membership|changeOrder":
          this.getAllProductEditListdetails();
          break;
      }
    });
  };

  getLastUpdatedTimeandDate = () => {
    this.apiserve.sendevent("ticketCms|membership|getLastUpdated", { type: 1 });
  };

  getAllProductEditListdetails = () => {
    let membershipId = this.props.MemberShipEditListId;
    this.apiserve.sendevent("ticketCms|membership|getDetail", { membershipId });
  };

  deleteFilm = () => {
    this.setState({
      deleteFilm: true,
    });
  };

  deleteFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|products|remove", {
      membershipId: this.props.MemberShipEditListId,
    });
  };

  publishFilm = () => {
    this.setState({
      publishFilm: true,
    });
  };

  publishFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|membership|updateStatus", {
      membershipId: this.props.MemberShipEditListId,
      status: 1,
    });
  };

  disableFilm = () => {
    this.setState({
      disableFilm: true,
    });
  };

  disableFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|membership|updateStatus", {
      membershipId: this.props.MemberShipEditListId,
      status: 2,
    });
  };

  discardPopupYes = () => {
    this.props.history.push({
      pathname: "/member-list"
    })
  }

  submitFn = async (e) => {
    e.preventDefault();
    this.setState({ loaderFlag: true });
    var sum = []
    this.state.Benefits.forEach((item) => {
      const name = convertToRaw(item.benefit_description.getCurrentContent());
      const summary = draftToHtml(name);
      const make = convertToRaw(item.redemption_description.getCurrentContent());
      const desc = draftToHtml(make);
      const change = {
        benefit_description: summary,
        redemption_description: desc
      }
      sum.push(change)
    })
    let updateproducts = {
      name: this.state.name,
      benefits: sum,
      price: this.state.price,
      accessType: this.state.accessType,
      membershipId: this.props.MemberShipEditListId,
      status: this.state.status,
      // group: this.state.group,
      // monthlyInstallments: this.state.monthlyInstallments
    };
    this.apiserve.sendevent("ticketCms|membership|update", updateproducts);
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };

  cancel = () => {
    this.setState({
      discardPopup: true
    })
  }
  onEditorStateChange = (summary, id) => {
    const sum = this.state.Benefits.forEach((item) => {
      if (item._id === id) { item.benefit_description = summary }
    })
    this.setState({})
  };
  onEditorState = (desc, id) => {
    const sum = this.state.Benefits.forEach((item) => {
      if (item._id === id) { item.redemption_description = desc }
    })
    this.setState({})
  };


  addBenefits = (item) => {
    let newBenifits = {
      _id: Math.random(),
      BenefitDescription: item ?.BenefitDescription,
      RedemptionDescription: item ?.RedemptionDescription,
    }
    var oldBenifits = this.state.Benefits
    oldBenifits.push(newBenifits)
    this.setState({
      Benefits: oldBenifits
    });
  }

  removeBenefits = (id) => {
    let filterBenifit = this.state.Benefits.filter(_ => _._id !== id)
    this.setState({
      Benefits: filterBenifit
    });
  }

  // checkInstallment = (e) => {
  //   this.setState({
  //     // monthlyInstallments: !this.state.monthlyInstallments
  //   },() => {
  //     if(this.state.monthlyInstallments){
  //         const price = this.state.price;
  //         price.monthly.max = this.state.price?.yearly?.max/12
  //         price.monthly.mid = this.state.price?.yearly?.mid/12
  //         price.monthly.min = this.state.price?.yearly?.min/12
  //         this.setState({
  //           price: price,
  //         });
  //     }
  //   })
  // }

  onDragEnd = (result) => {
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.Benefits];
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        benefits_id: _id,
        sortIndex: i + 1,
      });
    });

    const data = { membershipId: this.props.MemberShipEditListId, order: updateArr };

    this.apiserve.sendevent("ticketCms|membership|changeOrder", data);
    this.setState({ isDraggable: true });
    this.setState({ venueList: arr });
  }

  render() {

    const { getLastUpdated } = this.state;
    var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
    var hour = moment.tz(updateAt, "US/Mountain").format("h");
    var minutes = moment.tz(updateAt, "US/Mountain").format("mm");
    var state = moment.tz(updateAt, "US/Mountain").format("A");
    var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
    return (
      <React.Fragment>
        <div className="right_side_wrapper">
          <ul className="fpg_admin_tab disp_flex">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li className="active">
                    <p className="uppercase text_left">
                      <div>
                        {list.label}
                      </div>
                    </p>
                  </li>
                );
              })}
          </ul>

          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <Link className="back_link" to="/member-list">
              {" "}
              <svg width="5" height="10" viewBox="0 0 5 10" fill="none">
                {" "}
                <path d="M5 0L0 5L5 10V0Z" fill="black" />{" "}
              </svg>{" "}
              Back to List
            </Link>
            <p className="update_date">
              Last Update: {hour}:{minutes} {state} -{" "}
              {moment.tz(updateAt, "US/Mountain").format("MM/DD/YYYY")} Last Updated By:{" "}
              {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}
            </p>
          </div>
          <div className="product_detail_content fpg_tabcontent relative">
            <form>
              <div className="coupon_actions">
                <div className="fpg_edits_links d_flex d_flex_align_center d_flex_justify_end mt_0">
                  {/* <Link className="d_flex d_flex_align_center d_flex_justify_center"><FpgeeditIcon />EDIT</Link> */}
                  {this.state.status === 1 ?
                    <Link
                      className="d_flex d_flex_align_center d_flex_justify_center"
                      onClick={() => this.disableFilm()}
                    >
                      <FpgDisableIcon /> DISABLE
                    </Link>
                    :
                    <Link
                      className="d_flex d_flex_align_center d_flex_justify_center"
                      onClick={() => this.publishFilm()}
                    >
                      <FpgpublishIcon /> PUBLISH
                    </Link>
                  }
                  <Link
                    className="d_flex d_flex_align_center d_flex_justify_center"
                    onClick={() => this.deleteFilm()}
                  >
                    <FpgDeleteIcon />
                    DELETE
                  </Link>
                </div>
              </div>
              <div className="d_flex product_wrap_content">
                <div className="product_form product_coupon_form">
                  <div className="field_row horizontal_field">
                    <TextField
                      type="text"
                      label="Membership Name"
                      name="name"
                      value={this.state.name}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <div className="field_row horizontal_field">
                    <div className="field_row_inner">
                      <label>Payment Amounts</label>
                      <div className="field_input relative three_col_field disp_flex">
                        {this.state.price.yearly.map(item => {
                          return (
                            <div className="checkbox_field_row mr_10">
                              <TextField
                                type="number"
                                name="amount"
                                value={item.amount}
                                onChange={(e) => this.onInputMax(e, item._id)}
                              />
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label></label>
                        {/* <CheckBox name='monthlyInstallments' checked={this.state.monthlyInstallments} onChange={this.checkInstallment} label="Enable 12-Month Installments" type="CheckBox" id="Installments" /> */}
                      </div>
                    </div>
                    {/* {this.state.monthlyInstallments ?  
                      <div className="field_row_inner check_question">
                        <label></label>
                        <div className="field_input relative three_col_field disp_flex">
                            <div className="checkbox_field_row mr_10">
                              <TextField
                                type="text"
                                name="max"
                                value={this.state.price?.monthly?.max.toFixed(2)}
                                disable={true}
                              />
                            </div>
                            <div className="checkbox_field_row mr_10">
                              <TextField
                                type="text"
                                name="mid"
                                value={this.state.price?.monthly?.mid.toFixed(2)}
                                disable={true}
                              />
                            </div>
                            <div className="checkbox_field_row">
                              <TextField
                                type="text"
                                name="max"
                                value={this.state.price?.monthly?.min.toFixed(2)}
                                disable={true}
                              />
                            </div>
                        </div>
                      </div>
                      : ""} */}
                  </div>

                </div>
              </div>
              <div className="about_sundance benifit_section">
                <div className="section_box">
                  <div className="header">
                    <p>Your Benefits</p>
                  </div>
                  <div className="benifit_section_content">
                    <DragDropContext onDragEnd={this.onDragEnd}>
                      <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                          <ul {...provided.droppableProps} ref={provided.innerRef}>
                            {
                              this.state.Benefits.length > 0 && this.state.Benefits.map((item, index) => {
                                return (
                                  <Draggable
                                    key={item._id}
                                    draggableId={`'${item._id}'`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <li className=""
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps} >
                                        <div className="list_inner disp_flex d_flex_align_center d_flex_align_start">
                                          <span className="pointer d_flex dragger ml_5 mr_5"> <DraggerIcon /> </span>
                                          <p className="action_wrap d_flex d_flex_align_center action_wrap d_flex_justify_end">
                                            {
                                              index === 0 ?
                                                <span className="pointer" onClick={() => this.addBenefits(item)}>
                                                  <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                </span>
                                                :
                                                <>
                                                <span className="pointer mr_5" onClick={() => this.removeBenefits(item._id)}>
                                                  <FpgMinusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                </span>
                                                <span className="pointer" onClick={() => this.addBenefits(item)}>
                                                  <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                </span>
                                                </>
                                            }

                                          </p>
                                          <div className="form_group_textarea editor_wrapper ml_10 editor_400 mr_10">
                                            <div className="benifit_section_content_columnTitle editor_400 d_flex ">
                                              <p>Benefit Description</p>
                                            </div>
                                            <TextEditor
                                              editorState={item.benefit_description}
                                              name="benefit_description"
                                              value={item.benefit_description}
                                              onEditorStateChange={(e) => this.onEditorStateChange(e, item._id)}
                                            />
                                          </div>
                                          <div className="form_group_textarea editor_wrapper  editor_400">
                                            <div className="benifit_section_content_columnTitle editor_400">
                                              <p>Redemption Description</p>
                                            </div>
                                            <TextEditor
                                              editorState={item.redemption_description}
                                              name="redemption_description"
                                              value={item.redemption_description}
                                              onEditorStateChange={(e) => this.onEditorState(e, item._id)}
                                            />
                                          </div>
                                        </div>
                                      </li>
                                    )}
                                  </Draggable>
                                )
                              })}
                          </ul>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                </div>
              </div>
              <div className="text_center field_row w_100 buttons_outer">
                <button className="uppercase" onClick={e => this.cancel(e)} type="button">CANCEL</button>
                <button
                  className="uppercase active"
                  onClick={(e) => this.submitFn(e)}
                >
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>
        {this.state.deleteFilm ? (
          <PopUpCustomAll
            HeaderName="Deleted?"
            insideDetails="You are about to delete an item and this action is permanent"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.deleteFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.publishFilm ? (
          <PopUpCustomAll
            HeaderName="Publish Changes"
            insideDetails="Saving the current changes will publish it to the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.publishFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.disableFilm ? (
          <PopUpCustomAll
            HeaderName="Disable?"
            insideDetails="You are about to disable an item, which will temporarily make it unavailable on the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.disableFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.discardPopup ? (
          <PopUpCustomAll
            HeaderName="Discard Changes?"
            insideDetails="Leaving this page without saving will discard all changes"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.discardPopupYes}
          />
        ) : (
            ""
          )}
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, null)(ProductMemberDetail);